module.exports = __webpack_public_path__ + "static/media/loading_2.22ed99df.gif";